import axiosInstance from './axiosInstance';

/**
 * API methods related to timezone.
 */
export const TimeZoneAPI = {
  /**
   * Sets the user's timezone.
   *
   * @param {string} timezone - The new timezone value to set for the user.
   * @returns {Promise<any>} A promise that resolves with the server response upon success, or rejects with an error if the request fails.
   */
  setTimeZone: (timezone: string) => {
    return axiosInstance.post('/users/change-timezone', {
      timezone,
    });
  },
};
